import styled from "styled-components/macro";
import { withStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import { InfoOutline } from "@material-ui/icons";

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5em;
  align-items: center;
  justify-content: space-around;
  width: 30px;
`;

export const StyledLabel = styled.div`
  width: 6px;
  text-align: center;
`;

export const StyledTooltip = withStyles({
  tooltip: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontFamily: "Work Sans",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "14px",
    letterSpacing: "0.01em",
    border: "1px solid #DADCE0",
    borderRadius: "8px"
  }
})(Tooltip);

export const StyledInfoOutline = withStyles({
  root: {
    color: "#5F6368"
  }
})(InfoOutline);
